<h2 mat-dialog-title>Change Password</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="New Password"
      placeholder="Password"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Confirm Password"
      placeholder="Password"
      formControlName="passwordConf"
      type="password"
      [errorMessages]="{
        required: 'Confirm password is required',
        passwordMismatch: 'Passwords do not match',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Change Password</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
